import { Button, DropDownList, Input, Tables } from '@ixyberfree/ixybercomponents';
import { Editor, loader } from '@monaco-editor/react';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from 'store';
import { ICLStruct } from '../IConfiguration';

interface IPropsTypePage {
    num_type: number;
}

const VarsElement = ({ num_type }: IPropsTypePage): JSX.Element => {
    const { ICLibStore } = useStores();

    const val = ICLibStore.configLib().functions.variables[num_type];

    const [curType, setCurType] = React.useState<string>(Object.keys(val.vars)[0]);

    React.useEffect(() => {
        loader.config({ paths: { vs: '/ixyber/vision/vs' } });
        return () => {};
    }, []);

    const ChangeName = (name: string) => {
        let newState = { ...val };
        newState.name = name;
        ICLibStore.updateFunction(num_type, newState);
    };

    function ChangeType(value: any) {}

    const renderRow = (item: ICLStruct, i: number) => {
        return {
            name: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Input
                        key={'name' + item.name + i}
                        id={'name' + item.name + i}
                        width="100%"
                        type="text"
                        defaultValue={item.name}
                        onBlur={(v) => {}}
                    />
                </div>
            ),
            type: (
                <div onClick={(e) => e.stopPropagation()}>
                    <DropDownList
                        type={'text'}
                        width="100%"
                        key={'type' + item.name + i}
                        data={ICLibStore.systemTypeSelect}
                        selected={{ id: '', value: '' }}
                        // onClick={(item) => {}}
                        onElementClick={(value) => {
                            ChangeType(value);
                        }}
                    />
                </div>
            ),
            initVal: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Input
                        key={'initVal' + item.name + i}
                        width="100%"
                        id={'initVal' + item.name + i}
                        type="text"
                        defaultValue={item.initVal}
                        onBlur={(v) => {}}
                    />
                </div>
            ),
            label: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Input
                        key={'label' + item.name + i}
                        width="100%"
                        id={'label' + item.name + i}
                        type="text"
                        defaultValue={item.initVal}
                        onBlur={(v) => {}}
                    />
                </div>
            ),
            buttoncol: (
                <div>
                    <Button key={'buttoncol' + item.name + i} text="У" onClick={() => {}} />
                </div>
            )
        };
    };

    return (
        <React.Fragment>
            <Tables
                key={'variables' + num_type}
                width="100%"
                height="250px"
                header={[
                    { type: 'text', label: 'Имя', width: '200px', idCol: 'name' },
                    { type: 'text', label: 'Тип', width: '200px', idCol: 'type' },
                    { type: 'text', label: 'Исходное значение', width: '200px', idCol: 'initVal' },
                    { type: 'text', label: 'Описание', width: '200px', idCol: 'label' },
                    { type: 'text', label: '', width: '100px', idCol: 'buttoncol' }
                ]}
                data={val.vars.input
                    .map((item, i) => renderRow(item, i))
                    .concat(renderRow({ name: '', type: '' }, val.vars.input.length))}
            />

            <div style={{ paddingTop: '5px', width: '100%', height: 'calc(100% - 300px)' }}>
                <Editor language="st" value={val.body.data} width={'100%'} height={'100%'} />
            </div>
        </React.Fragment>
    );
};

const FunctionPage = ({ num_type }: IPropsTypePage): JSX.Element => {
    const { ICLibStore } = useStores();

    const val = ICLibStore.configLib().functions.variables[num_type];

    const ChangeName = (name: string) => {
        let newState = { ...val };
        newState.name = name;
        ICLibStore.updateFunction(num_type, newState);
    };

    return (
        <React.Fragment>
            Имя:{' '}
            <Input
                type="text"
                defaultValue={val.name}
                onBlur={(event) => ChangeName(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.currentTarget.blur();
                    }
                }}
            />
            <VarsElement num_type={num_type} />
        </React.Fragment>
    );
};

export default observer(FunctionPage);
